// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "main-sandbox-7.12.48-04844b68ec/assets/js/async/" + chunkId + "." + __webpack_require__.h().slice(0, 8) + ".js"
}